import React, { useEffect } from "react"
import { vismeWrapper } from "./visme.module.css"

const Visme = ({ id, title }) => {
  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://my.visme.co/visme-embed.js"
    script.async = true
    document.body.appendChild(script)
  }, [id])

  return (
    <div className={vismeWrapper}>
      <div
        className="visme_d"
        data-title={title}
        data-url={id}
        data-w="740"
        data-h="500"
        data-domain="my"
      ></div>
    </div>
  )
}

export default Visme
